import { useContext } from 'react';
import styled from 'styled-components';
import { GarmentDto } from '../../api/types/LookDtos';
import { CartItemsContext } from '../../context/CartItemsContext';
import { SelectedGarmentSizeContext } from '../../context/SelectedGarmentSizeContext';
import { CartItemsContextType } from '../../context/types/CartItemsContextType';
import { SelectedGarmentSizeContextType } from '../../context/types/SelectedGarmentSizeContextType';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { FiltersContext } from '../../context/FiltersContext';
import { FiltersContextType } from '../../context/types/FiltersContextType';
import { TextGarmentPreview, TextRegular } from '../Text';
import {
  MIN_PC_BODY_WIDTH,
  MIN_TABLET_BODY_WIDTH,
} from '../../constants/StylistConstants';

interface TransferGarment {
  garment: GarmentDto;
  active: boolean;
  id: number;
}

const Garment = (transferGarment: TransferGarment) => {
  const { updateCartItems } = useContext(
    CartItemsContext,
  ) as CartItemsContextType;
  const { selectedGarmentSizeId, saveSelectedGarmentSizeId } = useContext(
    SelectedGarmentSizeContext,
  ) as SelectedGarmentSizeContextType;
  const { appendFilterGarmentIds } = useContext(
    FiltersContext,
  ) as FiltersContextType;
  const garment: GarmentDto = transferGarment.garment;
  const garmentId: number = transferGarment.id;

  const mobileDisplay: boolean = window.innerWidth < MIN_TABLET_BODY_WIDTH;

  const quickBuy = () => {
    updateCartItems(1);
  };

  const sizeChange = (sizeId: number) => {
    saveSelectedGarmentSizeId(garmentId, sizeId);
  };

  return (
    <Container active={transferGarment.active}>
      <ImageContainer active={transferGarment.active}>
        <Image src={garment.images[0]} />
        {transferGarment.active && (
          <RemoveGarment onClick={() => appendFilterGarmentIds(garment.id)}>
            <RemoveIcon>
              <DeleteForeverIcon fontSize={'small'}></DeleteForeverIcon>
            </RemoveIcon>
            {!mobileDisplay && <TextGarmentPreview>delete</TextGarmentPreview>}
          </RemoveGarment>
        )}
        <FilterSizeWrapper>
          <FilterSize
            value={garment.sizes[selectedGarmentSizeId[garmentId]]}
            onChange={(e) => sizeChange(e.target.selectedIndex)}
          >
            {garment.sizes.map((size, index) => (
              <FilterSizeOption key={index}>{size}</FilterSizeOption>
            ))}
          </FilterSize>
        </FilterSizeWrapper>
      </ImageContainer>
      <InfoContainer>
        <TextRegular fontWeight={400}>{garment.name}</TextRegular>
        <QuickBuyGroup>
          <TextRegular fontWeight={400}>${garment.price}</TextRegular>
          <QuickBuy onClick={() => quickBuy()}>
            <TextRegular fontWeight={600}>+&nbsp;&nbsp; quick buy</TextRegular>
          </QuickBuy>
        </QuickBuyGroup>
      </InfoContainer>
    </Container>
  );
};

const Container = styled.div<{ active: boolean }>`
  width: 100%;
  flex: 1;
  position: relative;
  border-bottom: ${(props) => (props.active ? '5px solid #000000' : 'none')};
`;

const ImageContainer = styled.div<{ active: boolean }>`
  height: 383px;
  border: 1px solid #f3f3f3;
  box-shadow: ${(props) =>
    props.active ? '0px 0px 10px rgba(63, 65, 72, 0.25)' : '0'};
  position: relative;

  @media (max-width: ${MIN_PC_BODY_WIDTH - 1}px) {
    height: 366px;
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 190px;
  }
`;

const Image = styled.img`
  margin: 10%;
  width: 80%;
  height: 80%;
`;

const FilterSizeWrapper = styled.div`
  display: inline;
  background-color: white;
  position: absolute;
  bottom: 20px;
  right: 20px;
  &:after {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    pointer-events: none;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: 9px;
    right: 0.75em;
    border-top: 8px solid black;
    opacity: 0.5;

    @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      top: 7px;
      border-top: 6px solid black;
    }
  }

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    bottom: 5px;
    right: 5px;
  }
`;

const FilterSize = styled.select`
  background-color: white;
  -webkit-appearance: none;
  width: 44px;
  height: 23px;
  border: none;

  font-family: 'Poppins';
  font-style: normal;
  text-transform: lowercase;
  color: #000000;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 20px;
    font-size: 13px;
    line-height: 20px;
  }
`;

const RemoveGarment = styled.div`
  cursor: pointer;
  position: absolute;
  height: 23px;
  bottom: 20px;
  left: 20px;
  display: flex;
  align-items: center;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 20px;
    bottom: 5px;
    left: 5px;
  }
`;

const RemoveIcon = styled.div`
  height: 30px;
  width: 30px;
  margin-right: 10px;

  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;

  @media (max-width: ${MIN_TABLET_BODY_WIDTH - 1}px) {
    height: 20px;
    width: 20px;
    margin-right: 0;
  }
`;

const FilterSizeOption = styled.option``;

const InfoContainer = styled.div`
  width: 100%;
  word-break: break-word;
  position: relative;
  height: 135px;
  margin-top: 20px;
  margin-bottom: 30px;
  display: grid;
  grid-auto-rows: auto 0fr;
`;

const QuickBuyGroup = styled.div``;

const QuickBuy = styled.div`
  cursor: pointer;
`;

export default Garment;
